import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpHeaders,
  HttpClient,
  HttpErrorResponse
} from '@angular/common/http';
import Swal from 'sweetalert2';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject } from 'rxjs';
export const InterceptorSkipHeader = 'X-Skip-Interceptor';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class InterceptorService implements HttpInterceptor {

  constructor(private http: HttpClient, private toastr: ToastrService, private router: Router) { }

  LoginEncontrado$ = new BehaviorSubject<any>(null);

  public gerarNewToken() {
    try {

      var url: string = environment.advFirmasWebApi + '/Usuarios/Authenticate'
      var headers = new HttpHeaders().set(InterceptorSkipHeader, '');
      headers.append('Content-Type', 'application/json');

      let obj = {
        empresa: environment.empresa,
        usuario: environment.usuario,
        senha: environment.senha
      };

      this.http.post(url, obj, { headers: headers })
        .subscribe({
          next: (res: any) => {
            environment.expiracao = res.expira_em;
            environment.token = res.token;
            this.LoginEncontrado$.next(res);
          },
          complete: () => {
            this.LoginEncontrado$.unsubscribe();
            this.LoginEncontrado$ = new BehaviorSubject<any>(null);
          },
          error: (error: HttpErrorResponse) => {
            if (error.status == 400) {
              Swal.fire('Eiii!?...', 'Acesso inválido, por favor efetue o login novamente!', 'error');
            } else if (error.status === 500) {
              Swal.fire({
                'width': 500,
                'title': 'Oops...',
                'text': error.error.detail,
                'icon': 'error'
              });
            } else {
              Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
            }
          }
        });
    } catch (e) {
      throw e;
    }
  }


  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    try {

      var expira = environment.expiracao;
      var dataExpira = new Date(expira).getTime();
      var dataAtual = Date.now();

      if (req.headers.has(InterceptorSkipHeader)) {
        const headers = req.headers.delete(InterceptorSkipHeader);
        return next.handle(req.clone({ headers }));
      } else {
        if (dataAtual > dataExpira) {
          this.gerarNewToken();
          this.LoginEncontrado$.subscribe({
            next: (resp: any) => {
              const dupReq = req.clone({
                setHeaders: {
                  Authorization: "Bearer " + environment.token
                }
              });
              return next.handle(dupReq);
            }
          });
        } else {
          const dupReq = req.clone({
            setHeaders: {
              Authorization: "Bearer " + environment.token
            }
          });
          return next.handle(dupReq).pipe(tap(() => { }, (error: any) => {
            if (error instanceof HttpErrorResponse)
              if (error.status !== 401)
                return
              else {
                setTimeout(() => {
                  Swal.fire('Oops...', 'Parece que seu login expirou', 'error').then(r => {
                    this.router.navigate(['']);
                  });
                }, 100)
              }
          }));;
        }
      }

    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
    }
  }
}

